<template>
  <CRow>
    <CCol sm="12">
      <CCard>

        <CCardHeader>
          <CIcon name="cil-fingerprint" />
          <h5 class="d-inline ml-2">Activities</h5>
        </CCardHeader>

        <BackendTable />
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import BackendTable from "./BackendTable";

export default {
  name: "Activities",
  components: {
    BackendTable,
  },
};
</script>
